import { combineReducers } from 'redux';
import { info } from './info';

const appReducer = combineReducers({
  info,
});

export default (state, action) => appReducer(state, action);
